import Vue from 'vue'
import Router from 'vue-router'
import XgMain from '@/components/XgMain'
import XgWorks from '@/components/XgWorks'
import XgBSD from '@/components/XgBSD'
import XgAboutus from '@/components/XgAboutus'
import XgRecruit from '@/components/XgRecruit'
import XgContact from '@/components/XgContact'
import viewlayer from '@/components/viewlayer'
import PresentationView from '@/components/PresentationDetail'
import XgRequest from '@/components/XgRequest'
import XgPersonalInfo from '@/components/XgPersonalInfo'
import ErrorPage from '@/components/Error'

//project details
import lgchemHistory from '@/projects/lgchem-history'
import xeogen from '@/projects/xeogen'
import lotteAA from '@/projects/lotte-aa'
import dSteady from '@/projects/d-steady'
import lgWaterSolution from '@/projects/lgwatersolution'
import lgchemLifeScience from '@/projects/lgchem-life-science'
import serveOne from '@/projects/serveone'
import glovisAA from '@/projects/glovis-aa'
import pantos from '@/projects/pantos'
import premiumFoodMarket from '@/projects/premium-food-market'
import genesisShop from '@/projects/genesis-shop'
import iParkDutyFree from '@/projects/ipark-duty-free'
import lgChem from '@/projects/lgchem'
import lotteGroup from '@/projects/lotte-group'
import partecs from '@/projects/partecs'
import designSamsung from '@/projects/design-samsung'
import hyundaiSteel from '@/projects/hyundai-steel'
import ket from '@/projects/ket'
import haevichi from '@/projects/haevichi'
import hos from '@/projects/hos'
import ingLife from '@/projects/ing-life'
import ybTour from '@/projects/yb-tour'
import transys from '@/projects/transys'
import lotteTMS from '@/projects/lotte-tms'
import hanssemO4O from '@/projects/hanssem-o4o'
import innoceanDiscover from '@/projects/innocean-discover'
import dbLife from '@/projects/db-life'
import lgArchive from '@/projects/lg-archive'
import kbCard from '@/projects/kb-card'
import hosHk from '@/projects/hos-hk'
import lgEss from '@/projects/lg-ess'
import ketRenewal from '@/projects/ket-renewal'
import dbLifeSmartPhoneSales from '@/projects/db-life-smart-phone-sales'
import ezwelRenewal from '@/projects/ezwel-renewal'
import lgChemPrPortal from '@/projects/lg-chem-pr-portal'
import samsungSvc from '@/projects/samsung-svc'
import siliconworksRenewal from '@/projects/siliconworks-renewal'
import eznFoundation from '@/projects/ezn-foundation'
import omronHealthcare from '@/projects/omron-healthcare'
import serveoneRenewal from '@/projects/serveone-renewal'


Vue.use(Router)

const routes = [{
    path: '/uiux',
    name: 'xgWorks',
    component: XgWorks,
  },
  {
    path: '/visual-marketing',
    name: 'xgPpresentation',
    component: XgBSD,
  },
  {
    path: '/visual-marketing/:id',
    name: 'PresentationView',
    component: PresentationView,
  },
  {
    path: '/aboutus',
    name: 'xgAboutus',
    component: XgAboutus
  },
  {
    path: '/recruit',
    name: 'XgRecruit',
    component: XgRecruit
  },
  {
    path: '/contact',
    name: 'xgContact',
    component: XgContact
  },
  {
    path: '/request',
    name: 'xgRequest',
    component: XgRequest
  },
  {
    path: '/personalInfo',
    name: 'xgPersonalInfo',
    component: XgPersonalInfo
  },
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/main',
    name: 'xgMain',
    component: XgMain
  },

  //project 추가.. 하면 됩니다.2018.12.21
  {
    path: '/uiux/serveone-renewal', //URL 주소
    name: 'serveoneRenewal',
    component: serveoneRenewal
  },
  {
    path: '/uiux/omron-healthcare', //URL 주소
    name: 'omronHealthcare',
    component: omronHealthcare
  },
  {
    path: '/uiux/ezn-foundation', //URL 주소
    name: 'eznFoundation',
    component: eznFoundation
  },
  {
    path: '/uiux/siliconworks-renewal', //URL 주소
    name: 'siliconworksRenewal',
    component: siliconworksRenewal
  },
  {
    path: '/uiux/samsung-svc', //URL 주소
    name: 'samsungSvc',
    component: samsungSvc
  },
  {
    path: '/uiux/lg-chem-pr-portal', //URL 주소
    name: 'lgChemPrPortal',
    component: lgChemPrPortal
  },
  {
    path: '/uiux/ezwel-renewal', //URL 주소
    name: 'ezwelRenewal',
    component: ezwelRenewal
  },
  {
    path: '/uiux/db-life-smart-phone-sales', //URL 주소
    name: 'dbLifeSmartPhoneSales',
    component: dbLifeSmartPhoneSales
  },
  {
    path: '/uiux/db-life', //URL 주소
    name: 'dbLife',
    component: dbLife
  },
  {
    path: '/uiux/lg-archive', //URL 주소
    name: 'lgArchive',
    component: lgArchive
  },
  {
    path: '/uiux/kb-card', //URL 주소
    name: 'kbCard',
    component: kbCard
  },
  {
    path: '/uiux/hos-hk', //URL 주소
    name: 'hosHk',
    component: hosHk
  },
  {
    path: '/uiux/lg-ess', //URL 주소
    name: 'lgEss',
    component: lgEss
  },
  {
    path: '/uiux/ket-renewal', //URL 주소
    name: 'ketRenewal',
    component: ketRenewal
  },
  {
    path: '/uiux/innocean-discover', //URL 주소
    name: 'innoceanDiscover',
    component: innoceanDiscover
  },
  {
    path: '/uiux/hanssem-o4o', //URL 주소
    name: 'hanssemO4O',
    component: hanssemO4O
  },
  {
    path: '/uiux/lotte-tms', //URL 주소
    name: 'lotteTMS',
    component: lotteTMS
  },
  {
    path: '/uiux/transys', //URL 주소
    name: 'transys',
    component: transys
  },
  {
    path: '/uiux/yb-tour', //URL 주소
    name: 'ybTour',
    component: ybTour
  },
  {
    path: '/uiux/ing-life', //URL 주소
    name: 'ingLife',
    component: ingLife
  },
  {
    path: '/uiux/hos', //URL 주소
    name: 'hos',
    component: hos
  },
  {
    path: '/uiux/lgchem-history',
    name: 'lgchemHistory',
    component: lgchemHistory
  },
  {
    path: '/uiux/xeogen',
    name: 'xeogen',
    component: xeogen
  },
  {
    path: '/uiux/lotte-aa',
    name: 'lotteAA',
    component: lotteAA
  },
  {
    path: '/uiux/d-steady',
    name: 'dSteady',
    component: dSteady
  },
  {
    path: '/uiux/lgwatersolution',
    name: 'lgWaterSolution',
    component: lgWaterSolution
  },
  {
    path: '/uiux/lgchem-life-science',
    name: 'lgchemLifeScience',
    component: lgchemLifeScience
  },
  {
    path: '/uiux/serveone',
    name: 'serveOne',
    component: serveOne
  },
  {
    path: '/uiux/glovis-aa',
    name: 'glovisAA',
    component: glovisAA
  },
  {
    path: '/uiux/pantos',
    name: 'pantos',
    component: pantos
  },
  {
    path: '/uiux/premium-food-market',
    name: 'premiumFoodMarket',
    component: premiumFoodMarket
  },
  {
    path: '/uiux/genesis-shop',
    name: 'genesisShop',
    component: genesisShop
  },
  {
    path: '/uiux/ipark-duty-free',
    name: 'iParkDutyFree',
    component: iParkDutyFree
  },
  {
    path: '/uiux/lgchem',
    name: 'lgChem',
    component: lgChem
  },
  {
    path: '/uiux/lotte-group',
    name: 'lotteGroup',
    component: lotteGroup
  },
  {
    path: '/uiux/partecs',
    name: 'partecs',
    component: partecs
  },
  {
    path: '/uiux/design-samsung',
    name: 'designSamsung',
    component: designSamsung
  },
  {
    path: '/uiux/hyundai-steel',
    name: 'hyundaiSteel',
    component: hyundaiSteel
  },
  {
    path: '/uiux/ket',
    name: 'ket',
    component: ket
  },
  {
    path: '/uiux/haevichi',
    name: 'haevichi',
    component: haevichi
  },
  {
    path: '*',
    component: ErrorPage
  }
]

export default new Router({
  mode: 'history',
  base: '/',
  routes: routes,
  linkActiveClass: "is-active",
  linkExactActiveClass: "exact-active",
})



// WEBPACK FOOTER //
// ./src/router/index.js